<template>
  <div class="Login">
    <el-container class="LoginBox">
      <el-dialog
          center
          :title="$t('login.dialogSuspendedTitle')"
          :visible.sync="isSuspended"
          :close-on-click-modal="false"
          :show-close="true"
          :close-on-press-escape="true"
          width="40%">
        <div v-html="$t('login.dialogSuspendedText')" style="text-align: center;"></div>
        <span slot="footer" class="dialog-footer"></span>
      </el-dialog>

      <el-header class="LoginBox-header">
        <img
                alt=""
                src="@/assets/login_logo.png"
                srcset="@/assets/login_logo@2x.png 2x"
        />
      </el-header>
      <el-main class="LoginBox-main">
        <h1>{{ $t("login.title") }}</h1>
        <p>
          {{ $t("login.titleDescription") }}
        </p>
        <el-form
                ref="loginForm"
                label-position="top"
                v-loading="isAuthenticating"
                :model="loginForm"
                :rules="loginFormRules"
                @submit-valid="tryLogin"
                @submit-error="onError"
        >
          <el-form-item prop="username">
            <template slot="label">{{ $t(labelUsername) }}</template>
            <el-input
                    type="text"
                    v-model="loginForm.username"
                    :placeholder="$t(labelUsernamePlaceholder)"
                    @blur="resetError()"
            />
          </el-form-item>
          <el-form-item prop="password">
            <template slot="label">{{ $t("login.password") }}</template>
            <el-input :type="typePassword" v-model="loginForm.password" :placeholder="$t('login.passwordPlaceholder')" @blur="resetError()">
              <div slot="append"><img @click="handlePassword" :src="require(`@/assets/${eyeFilename}`)" width="20"></div>
            </el-input>
          </el-form-item>
          <div v-if="error && loginForm.username != null && loginForm.username!= undefined && loginForm.username != '' &&
                                  loginForm.password != null && loginForm.password!= undefined && loginForm.password != ''"
               class="error">{{ error }}
          </div>
          <el-button
                  class="Login-formSubmit w-100"
                  native-type="submit"
                  type="danger"
          >{{ $t("login.logIn") }}
          </el-button
          >
        </el-form>
      </el-main>
      <el-footer class="LoginBox-footer" height="auto">
        <h3>{{ $t("login.passwordLost") }}</h3>
        <router-link to="motDePassePerdu" class="LoginBox-reinitPassword">
          <el-link>{{ $t("login.passwordLostLink") }}</el-link>
        </router-link>
      </el-footer>
    </el-container>
    <div class="Login-slogan" v-if="browserContext.up('xl')">
      <img
              alt=""
              :src="require(`@/assets/${loginSlogan}.png`)"
              :srcset="require(`@/assets/${loginSlogan}@2x.png`) + ' 2x'"
      />
    </div>

    <languages></languages>

    <div class="Login-footer">
      <a :href="websiteUrl" target="_blank" rel="noopener">{{ $t("general.ubiflowWebsite") }}</a>
    </div>
  </div>
</template>

<script>
import { tryAuthenticateWithUsernameOrEmailAndPassword, tryAuthenticateWithToken, signOut } from '@/services/auth'
import { updateUser, checkResetPasswordStatusSFC } from '@/services/users'
import Languages from '../components/Languages'
import i18next from 'i18next'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  components: {
    Languages
  },
  inject: ['browserContext'],
  metaInfo () {
    return {
      title: this.$t('login.metaTitle'),
      htmlAttrs: {
        class: 'Root--login'
      }
    }
  },
  data () {
    if (this.$t) {
      return {
        response: {},
        isAuthenticating: false,
        isSuspended: false,
        error: null,
        loginForm: {},
        loginFormRules: {
          username: { required: true, message: this.$t('validator.usernameRequired') },
          password: { required: true, message: this.$t('validator.passwordRequired') }
        },
        showPassword: false,
        eyeFilename: 'icon-eye.png',
        typePassword: 'password'
      }
    } else {
      return {
        response: {},
        isAuthenticating: false,
        error: null,
        loginForm: {},
        loginFormRules: {
          username: { required: true, message: 'username required' },
          password: { required: true, message: 'password required' }
        },
        showPassword: false,
        eyeFilename: 'icon-eye.png',
        typePassword: 'password'
      }
    }
  },
  methods: {
    onError (error) {
      this.error = error
    },
    handlePassword () {
      this.showPassword = !this.showPassword
      if (this.showPassword) {
        this.eyeFilename = 'icon-eye-hide.png'
        this.typePassword = 'text'
      } else {
        this.eyeFilename = 'icon-eye.png'
        this.typePassword = 'password'
      }
    },
    async tryLogin () {
      if (this.$ga) {
        this.$ga.event('page_login', 'clic', 'se_connecter')
      }
      this.isAuthenticating = true
      this.error = null
      const { username, password } = this.loginForm
      try {
        const result = await tryAuthenticateWithUsernameOrEmailAndPassword(username, password)
        if (!result) {
          return (this.error = this.$t('error.unknown'))
        } else if (result.status && (result.status == 'SUSPENDU')) {
          this.isSuspended = true
          return
        } else if (this.isSFC) {
          this.getUser.lastSFCSuccessfullyRedirectedLoginAt = moment()
          updateUser(this.getUser)
        }
        this.$router.push(
          ((this.$route.params && this.$route.params.redirect) || (this.$route.query && this.$route.query.redirect)) || {
            name: 'dashboard'
          }
        )
      } catch (err) {
        this.error = this.$t(err.message)
      } finally {
        this.isAuthenticating = false
      }
    },
    resetError () {
      this.error = null
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    websiteUrl () {
      return processEnvConfig.VUE_APP_UBIFLOW_WEBSITE_URL
    },
    loginSlogan () {
      if (i18next.language === 'mx') {
        return 'login_slogan_es'
      }
      return 'login_slogan_' + i18next.language
    },
    isSFC () {
      return this.$route.query.externalId && this.$route.query.networkCode && this.$route.query.dbksUserLogin
    },
    labelUsername () {
      return this.isSFC ? 'login.usernameSFC' : 'login.username'
    },
    labelUsernamePlaceholder () {
      return this.isSFC ? 'login.usernamePlaceholderSFC' : 'login.usernamePlaceholder'
    }
  },
  async beforeMount () {
    if (this.$route.params && this.$route.params.signout) {
      await signOut()
    }

    this.isAuthenticating = true
    this.error = null
    try {
      let token = null
      if (this.$route.query.token) {
        token = this.$route.query.token
      } else if (this.$route.params.token) {
        token = this.$route.params.token
      }
      if (token) {
        const result = await tryAuthenticateWithToken(token)
        if (!result) {
          return (this.error = this.$t('error.unknown'))
        }

        this.$router.push(
          ((this.$route.params && this.$route.params.redirect) || (this.$route.query && this.$route.query.redirect)) || {
            name: 'dashboard'
          }
        )
      }
      // SFC Connection ex: espace-client.localhost/login?externalId=dbricks&networkCode=UBSFC&dbksUserId=13684&dbksUserLogin=alain.delaunay@digitalb.pro
      if (this.isSFC) {
        const result = await checkResetPasswordStatusSFC(this.$route.query)
        if (result === 'No sugar account founded' || result === 'No EC account founded') {
          this.$router.push({ name: 'SFCConnectionError' })
        } else if (result && result.SFCPasswordReseted === false) {
          this.$router.push({ name: 'lostPasswordSFC', params: { email: this.$route.query.dbksUserLogin } })
        }
      }
    } catch (err) {
      this.error = this.$t(err.message)
    } finally {
      this.isAuthenticating = false
    }
  }
}
</script>

<style lang="scss">
  @import "@/theme/_bootstrap.scss";

  .el-loading-spinner {
    top: 10% !important;
  }

  html.Root--login {
    &,
    body {
      height: 100%;
    }

    body {
      align-items: center;
      background: url("~@/assets/login_background.jpg");
      @include image-retina("~@/assets/login_background.jpg", 2880, 1620);
      background-position: center center;
      background-size: cover !important;
      background-attachment: fixed;
      background-repeat: no-repeat;
      display: flex;
      flex: 1;
      justify-content: center;
      padding: 0;
      @media screen and (max-height: 760px) {
        align-items: flex-start;
      }
    }
  }

  .Login {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .LoginBox {
      @extend .card, .mx-4, .mb-5;
      max-width: 420px;
      margin-top: map-get($spacers, 5) * 2 !important;
      @media screen and (max-height: 760px) {
        margin-top: 60px + map-get($spacers, 5) * 2 !important;
      }

      h1 {
        border-bottom: 1px solid $blue;
        @include media-breakpoint-down(xs) {
          // Cannot use @extend in media
          padding-bottom: map-get($spacers, 4) !important; // pb-4
        }
      }

      &-header {
        position: absolute;
        text-align: center;
        transform: translateY(-100%);
        top: map-get($spacers, 5) * -1;
        width: 100%;
        height: 60px;

        img {
          max-width: 100%;
        }
      }

      &-main {
        @extend .card-body;
      }

      &-footer {
        background: $yellow-pastel;
        @extend .card-footer;
      }

      &-reinitPassword {
        font-size: $font-size-sm-alt;
      }
    }

    &-slogan {
      @extend .font-secondary;
      color: $white;
      font-size: $font-size-base * 2;
      font-weight: lighter;
      line-height: $font-size-base * 2.5;
      position: absolute;
      right: 20%;
      text-align: center;
      top: 50%;
      transform: translate(50%, -50%);
      width: 200px;

      .fifteen {
        @extend .text-warning;
        font-size: $font-size-base * 5;
        line-height: $font-size-base * 4.5;
        display: block;
      }

      .simplify {
        @extend .text-primary;
        display: block;
      }
    }

    &-footer {
      @extend .px-4, .py-3, .text-right;
      font-size: $font-size-sm;
      background: rgba(22, 64, 77, 0.8);
      bottom: 0;
      font-weight: lighter;
      left: 0;
      position: fixed;
      right: 0;

      @media screen and (max-height: 760px) {
        position: static;
        width: 100%;
      }

      a {
        color: $white;
      }
    }
  }

  .error {
    color: #d24554;
  }
</style>
